import { ThemeProvider as FluentThemeProvider } from '@fluentui/react/lib/utilities/ThemeProvider';
import React, { FC } from 'react';

import { HighContrastEmulationClassName } from '../../util/styles/highContrastEmulation';
import useAppendBodyClassName from '../../util/useAppendBodyClassName';

import { DarkThemeClassName, LightThemeClassName, getClassNames } from './AppContainer.styles';
import { AppContainerProps } from './AppContainer.types';
import { useLoadTheme, useThemeWithComponentStyleOverrides } from './hooks';

const AppContainer: FC<AppContainerProps> = ({
  children,
  theme,
  emulateHighContrast = false,
  suppressGlobalStyles = false,
  useTransparentBackground = false,
}) => {
  useAppendBodyClassName(HighContrastEmulationClassName, emulateHighContrast);

  const isDarkMode = !!theme?.isInverted;
  const shouldAppendBodyDarkClassName = isDarkMode && !suppressGlobalStyles;
  useAppendBodyClassName(DarkThemeClassName, shouldAppendBodyDarkClassName);

  const shouldAppendBodyLightClassName = !isDarkMode && !suppressGlobalStyles;
  useAppendBodyClassName(LightThemeClassName, shouldAppendBodyLightClassName);

  const themeWithComponentOverrides = useThemeWithComponentStyleOverrides(theme);
  useLoadTheme(suppressGlobalStyles, themeWithComponentOverrides);

  const classNames = getClassNames(
    themeWithComponentOverrides,
    suppressGlobalStyles,
    emulateHighContrast,
    useTransparentBackground
  );

  return (
    <FluentThemeProvider theme={themeWithComponentOverrides} className={classNames.appContainer} applyTo="none">
      {children}
    </FluentThemeProvider>
  );
};

/**
 * AppContainer sets some baseline visual and accessibility styling.
 */
export default AppContainer;
